import { useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../config/firebase';

/**
 * Custom hook for managing authentication state
 * @param {Function} navigate - Navigation function from react-router-dom
 * @returns {Object} - { user, setUser, handleLogout, loading }
 */
export const useAuth = (navigate) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);

      const isPublicRoute = window.location.pathname === "/explore" || 
                           window.location.pathname.startsWith("/exercise/") ||
                           window.location.pathname === "/preview" ||
                           window.location.pathname === "/workout" ||
                           window.location.pathname === "/complete" ||
                           window.location.pathname === "/custom-workout";

      if (!currentUser) {
        if (!isPublicRoute) {
          navigate("/login");
        }
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log("Current user after sign out:", auth.currentUser);
      navigate("/explore");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return {
    user,
    setUser,
    handleLogout,
    loading
  };
};

export default useAuth;
